// extracted by mini-css-extract-plugin
module.exports = {"c":"styles_c__2JQH2","front":"styles_front__eNKN-","back":"styles_back__3VFO9","container":"styles_container__2hvUS"};